import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpaceModule } from 'ng-zorro-antd/space';

@Component({
    selector: 'app-forgot-password',
    imports: [ReactiveFormsModule,
        NzGridModule,
        TranslateModule,
        NzFlexModule,
        NzTypographyModule,
        NzButtonModule,
        NzDividerModule,
        NzIconModule,
        NzImageModule,
        NzFormModule,
        NzInputModule,
        NzSpaceModule,
        NzModalModule,
        CommonModule],
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ForgotPasswordComponent {

  isSuccessModalVisible = false;
  isErrorModalVisible = false;

  forgotPasswordForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  constructor(
    private fb: NonNullableFormBuilder,
    private http: HttpService,
    private router: Router
  ) {}

  submit() {
    if (this.forgotPasswordForm.valid) {
      const email = this.forgotPasswordForm.value.email;
      if(email){
        this.http.resetPassword(email).subscribe({
            next: () => {
              this.isSuccessModalVisible = true;
            },
            error: () => {
              this.isErrorModalVisible = true;            
            }
        });
      } 
    }
  }

  showSuccessModal(): void {
    this.isSuccessModalVisible = true;
  }

  handleSuccessOk(): void {
    this.isSuccessModalVisible = false;
  }

  showErrorModal(): void {
    this.isErrorModalVisible = true;
  }

  handleErrorOk(): void {
    this.isErrorModalVisible = false;
  }
  
  goBack() {
    this.router.navigate(['/login']);
  }

}
